import { Box } from "@mui/system";

import { Alert, Button, Typography } from "@mui/joy";
import { Helmet } from "react-helmet";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { heightWithToolbar } from "../global";
import EmailsDataGrid from "../hooks/EmailsDataGrid";
import SlidingDialog from "../hooks/SlidingDialog/SlidingDialog";
import { usePro } from "../hooks/usePro/usePro";
import { useDispatch } from "react-redux";
import { setFormOpen } from "../reducers/rhapsody";

export default function Emails() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pro = usePro();

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1600,
          width: "100vw",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Emails</title>
        </Helmet>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography level="h6">Emails</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            height: "100%",
            position: "relative",
          }}
        >
          {/* {!pro && (
            <Box
              sx={{
                height: "100%",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                position: "absolute",
              }}
            >
              <Alert
                endDecorator={
                  <Button
                    onClick={() =>
                      dispatch(
                        setFormOpen({ isOpen: true, formID: "upgradeOpen" })
                      )
                    }
                    sx={{ ml: 1 }}
                    size="sm"
                    color="info"
                    variant="soft"
                  >
                    Subscribe Now
                  </Button>
                }
                startDecorator={
                  !pro ? (
                    <Typography
                      sx={{ color: "white" }}
                      variant="outlined"
                      color="neutral"
                      level="body5"
                    >
                      PRO
                    </Typography>
                  ) : undefined
                }
                variant="solid"
                color="info"
              >
                Email History is a Pro feature
              </Alert>
            </Box>
          )} */}
          <Box
            sx={{
              display: "flex",
              // filter: !pro ? "blur(5px)" : "blur(0px)",
              transition: "filter .3s",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              // pointerEvents: !pro ? "none" : undefined,
            }}
          >
            <EmailsDataGrid />
          </Box>
        </Box>
        {params.emailID ? (
          <SlidingDialog open onClose={() => navigate(-1)}>
            <Outlet />
          </SlidingDialog>
        ) : (
          []
        )}
      </Box>
    </>
  );
}
